// slider(slick)
jQuery(function($){
  // ▼施工事例のビフォーアフターspのときだけ
  if ($('#js-works-gallery').length) {
    // 変数
    var _winWidth = window.innerWidth;
    var $worksSliderWrap = $('#js-works-gallery-wrap');
    var $worksSlider = $('#js-works-gallery');
    // スライド初期化時にクラスを追加
    // はじめはdisplay:noneしておき、.initializedが追加されたらdisplay:block
    $worksSlider.on('init', function(){
      $worksSliderWrap.addClass('initialized');
    });
    if (_winWidth < 1024) {
      $worksSlider.slick({
        mobileFirst: true,
        arrows: true,
        appendArrows: $worksSliderWrap,
        prevArrow: '<p class="s-works-gallery-arrow s-works-gallery-arrow--type_prev"><span class="icon"><i class="fas fa-chevron-circle-left"></i></span></p>',
        nextArrow: '<p class="s-works-gallery-arrow s-works-gallery-arrow--type_next"><span class="icon"><i class="fas fa-chevron-circle-right"></i></span></p>',
        dots: false,
        autoplay: false,
        // autoplaySpeed: 3000,
        infinite: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              arrows: false
            }
          }
        ]
      });
    }
  }
  // ▼そとだんについての施工の流れスライド
  if ($('.js-flow-slide').length) {
    // 変数
    var $flowSlideWrap = $('.js-flow-slide-wrap');
    var $flowSlide = $('.js-flow-slide');
    // スライド初期化時にクラスを追加
    // はじめはdisplay:noneしておき、.initializedが追加されたらdisplay:block
    $flowSlide.on('init', function(){
      $flowSlideWrap.addClass('initialized');
    });
    $flowSlide.each(function(_slideIndex) {
      // $thisSlideNav = $slideNav.eq(_slideIndex);
      $flowSlide.eq(_slideIndex).slick({
        mobileFirst: true,
        fade: false,
        waitForAnimate: true,//フェードのときはfalseにした方が動作が良い感じ
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        dotsClass: 's-flow-slide__nav',
        customPaging: function(slick, index){
          return '<p class="s-flow-slide__navItem"></p>';
        },
        autoplay: false,
        // speed: 1000,
        cssEase: 'ease',
        draggable: true,
        arrows: true,
        appendArrows: $flowSlide.eq(_slideIndex).parent('.js-flow-slide-wrap'),
        prevArrow: '<p class="s-flow-slide-arrow s-flow-slide-arrow--type_prev"><span class="icon"><i class="fas fa-chevron-circle-left"></i></span></p>',
        nextArrow: '<p class="s-flow-slide-arrow s-flow-slide-arrow--type_next"><span class="icon"><i class="fas fa-chevron-circle-right"></i></span></p>',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
            }
          }
        ]
      });
    });
  }
});
